export default {
  root: {
    borderRadius: 16
  }
};
